import { useQuery } from "@-/com.npmjs.tanstack__react-query";

import type { SentenceWord } from "#sentence-word";
import { useSentenceWordsQueryOptions } from "#use-sentence-words-query";

export type UseSentenceWordsResult = {
  isPending: boolean;
  /**
   * Segmented words (each with its reading) once the query resolves; `undefined` while the
   * vocabulary lookup is in flight.
   */
  words: SentenceWord[] | undefined;
};

/**
 * Segment a sentence into tappable words, each carrying its tone-numbered pinyin reading. The
 * vocabulary now lives in the static DB instead of a bundled JSON, so segmentation is async: until
 * the per-sentence word lookup resolves, callers should fall back to rendering the raw sentence text.
 * See {@link useSentenceWordsQueryOptions}.
 */
export function useSentenceWords(sentence: string): UseSentenceWordsResult {
  const { data, isPending } = useQuery(useSentenceWordsQueryOptions(sentence));
  return { isPending, words: data };
}
